/** Соответствует категориям на бэкенде (inferNotificationCategory) */
export const NOTIFICATION_CATEGORY_LABELS: Record<string, string> = {
    subscription: "Подписка",
    clients: "Клиенты",
    account: "Профиль и данные",
    broadcast: "Рассылки",
    chat: "Чаты на сайте",
    system: "Системные",
};

export const NOTIFICATION_CATEGORY_FILTER_OPTIONS: { label: string; value: string }[] = [
    { label: "Все", value: "all" },
    { label: "Подписка", value: "subscription" },
    { label: "Клиенты", value: "clients" },
    { label: "Профиль и данные", value: "account" },
    { label: "Чаты", value: "chat" },
    { label: "Рассылки", value: "broadcast" },
    { label: "Системные", value: "system" },
];
